import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {debouncedScrollTriggerRefresh} from "../scripts/functions/gsapDebouncedFunctions";

gsap.registerPlugin(ScrollTrigger);

export async function initBlocks(container) {

  const blocks = container.querySelectorAll('[data-section-class]');

  // for (let block of blocks) {
  //   ScrollTrigger.create({
  //     trigger: block,
  //     start: 'top 120%',
  //     end: 'bottom -20%',
  //     onToggle({isActive}) {
  //       block.classList.toggle('visible', isActive);
  //     }
  //   })
  // }
  const preLoadedBlocks = blocks.length;

  async function loadRemainingBlocks() {
    console.log('remaining')
    window.removeEventListener('scroll', loadRemainingBlocks);
    for (let i = 0; i < blocks.length - preLoadedBlocks; i++) {
      const block = blocks[i + preLoadedBlocks];
      const {default: blockScript} = await import('./' + block.dataset.sectionClass)
      block.classList.add('js-loaded')
      await blockScript(block);
    }

    // footer
    debouncedScrollTriggerRefresh();

  }

  const footer = container.querySelector('footer');
  if (footer) {
    const {default: blockScript} = await import('./footer_block');
    await blockScript(footer);
    //
  }

  for (let i = 0; i < blocks.length; i++) {
    if (i < preLoadedBlocks && !/^hero_block$|^header$/.test(blocks[i].dataset.sectionClass)) {
      const block = blocks[i];
      const {default: blockScript} = await import('./' + block.dataset.sectionClass)
      block.classList.add('js-loaded')
      await blockScript(block);
    }
  }
  // await loadRemainingBlocks();
  window.scrollY > (document.location.pathname === "/" ? 1 : 50) ? await loadRemainingBlocks() : window.addEventListener('scroll', loadRemainingBlocks);
}
